var head = document.getElementsByTagName('head')[0]
var static_servers = '//res.jzyx.com'
var url_config = {
  md5: '/themes/commons/js/jz.md5.min.js',
  login: '/themes/commons/jz-login/jz-login-1.0.0.min.js',
  register: '/themes/commons/jz-register/jz-register-1.2.0.min.js'
}

/**
 * Load an external script.
 *
 * @param  {string}  type url 类型
 * @param  {fuction} cb   js 加载完成后回调
 */
export default function(type, cb) {
  var script = document.createElement('script')
  script.charset = 'UTF-8'
  script.async = true
  script.onerror = function() {
    if (cb) cb(true)
  }

  var loaded = false
  script.onload = script.onreadystatechange = function() {
    if (
      !loaded &&
      (!script.readyState ||
        'loaded' === script.readyState ||
        'complete' === script.readyState)
    ) {
      loaded = true
      if (cb) {
        setTimeout(function() {
          cb(false)
        }, 0)
      }
    }
  }

  script.src = static_servers + url_config[type]
  head.appendChild(script)
}
